import Vue from "vue";
import viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import "../style/view-img.scss";
Vue.use(viewer);
